import React from 'react';
import styles from '../assets/global.css'

export default function Footer(){
  return (
    <footer className="footer">
      <div>
          Made by constantinp2022 as part of NEAR MetaBUILD III Hackathon.
      </div>
    </footer>
  );
};
